import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import moment from 'moment';


export const FinancialInformationForm = ({ dto, errorInputs, handleInputChange, t }) => {

    return (
        <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid size={{ xs: 12}}>
                <Typography variant="h6">{t("suppliers.financialInformationManual")}</Typography>
            </Grid>

            <Grid size={{ xs: 4, sm: 4 }}>
                <TextField
                    fullWidth
                    label={t("suppliers.financial.totalAssets")}
                    name="total_assets"
                    value={dto.total_assets}
                    onChange={handleInputChange}
                    type="number"
                    size='small'
                    error={Boolean(errorInputs.total_assets?.isError)}
                    helperText={errorInputs.total_assets?.messageError || ''}
                    required
                />
            </Grid>

            <Grid size={{ xs: 4, sm: 4 }}>
                <TextField
                    fullWidth
                    label={t("suppliers.financial.totalLiabilities")}
                    name="total_liabilities"
                    onChange={handleInputChange}
                    type='number'
                    size='small'
                    value={dto.total_liabilities}
                    error={Boolean(errorInputs.total_liabilities?.isError)}
                    helperText={errorInputs.total_liabilities?.messageError || ''}
                    required
                />
            </Grid>

            <Grid size={{ xs: 4, sm: 4 }}>
                <TextField
                    fullWidth
                    label={t("suppliers.financial.patrimony")}
                    name="patrimony"
                    value={dto.patrimony}
                    onChange={handleInputChange}
                    type="number"
                    size='small'
                    error={Boolean(errorInputs.patrimony?.isError)}
                    helperText={errorInputs.patrimony?.messageError || ''}
                    required
                />
            </Grid>

            <Grid size={{ xs: 4, sm: 4 }}>
                <TextField
                    fullWidth
                    label={t("suppliers.financial.monthlyIncome")}
                    name="monthly_income"
                    value={dto.monthly_income}
                    onChange={handleInputChange}
                    type="number"
                    size='small'
                    error={Boolean(errorInputs.monthly_income?.isError)}
                    helperText={errorInputs.monthly_income?.messageError || ''}
                    required
                />
            </Grid>

            <Grid size={{ xs: 4, sm: 4 }}>
                <TextField
                    fullWidth
                    label={t("suppliers.financial.expenses")}
                    name="expenses"
                    value={dto.expenses}
                    onChange={handleInputChange}
                    type="number"
                    size='small'
                    error={Boolean(errorInputs.expenses?.isError)}
                    helperText={errorInputs.expenses?.messageError || ''}
                    required
                />
            </Grid>

            <Grid size={{ xs: 4, sm: 4 }}>
                <TextField
                    fullWidth
                    label={t("suppliers.financial.otherIncome")}
                    name="other_income"
                    value={dto.other_income}
                    onChange={handleInputChange}
                    type="number"
                    size='small'
                    error={Boolean(errorInputs.other_income?.isError)}
                    helperText={errorInputs.other_income?.messageError || ''}
                    required
                />
            </Grid>

            <Grid size={{ xs: 12, md: 4 }}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                        label={t("suppliers.financial.cutoffDate")}
                        value={dto.cutoff_date_information || null}
                        maxDate={new Date()}
                        inputFormat="dd/MM/yyyy"
                        onChange={(newValue) => {
                            handleInputChange({
                                target: { name: 'cutoff_date_information', value: moment(newValue).format('DD/MM/YYYY') }
                            });
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                name={'cutoff_date_information'}
                                size="small"
                                fullWidth
                                required
                                error={Boolean(errorInputs.cutoff_date_information?.isError)}
                                helperText={errorInputs.cutoff_date_information?.messageError}
                                InputLabelProps={{ shrink: true }}
                            />
                        )}
                    />
                </LocalizationProvider>
            </Grid>

        </Grid>
    );
};
